/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */
import Logo from '../../../common-assets/images/logo.png';
import iconReadMore from '../../../common-assets/images/read_more.png';
export const DEFAULT_LOCALE = 'en';
export default ({
  // General
  name: 'Boxpressd',
  copyright: '© 2019 Boxpressd Limited',
  reserved: 'All rights reserved',
  // Define Article
  textReadMore: 'Read More',
  sizeReadMore: 30,
  iconReadMore,
  logo: Logo,
  sizeLogo: 30,
  colorFontIcon: '#69798F',
  sizeFontICon: 16,
  sizeFontIConList: 28,


  // Define ColorTopBar
  // colorTopBar: '#69798F',
  // iconMenu: 'menu-homepage',
  // iconSizeMenu: 20,


  // Black Color theme
  colorTopBar: 'rgba(255, 255, 255, 0.5)',
  iconMenu: 'icon-home',
  iconSizeMenu: 24,

  // Search
  sizeIconSearch: 25,
  colorIconSearch: '#eeeeee',


  // Define Email Box
  textSubscribe: 'SUBSCRIBE',
  textEmailAddress: 'Email address',
  textSendMail: 'Send',
  // Category Video Id
  categoryVideoId: 34,
  // Tag Video Keyword
  categoryVideoTag: 'video',

  // footer
  linkFacebook: 'http://facebook.com/boxpressd',
  linkGoogle: 'http://plus.google.com/boxpressd',
  linkTwitter: 'http://twitter.com/boxpressd',

  // Link Social Share
  shareFacebook: 'http://facebook.com/boxpressd',
  shareGoogle: 'http://plus.google.com/boxpressd',
  shareTwitter: 'http://twitter.com/boxpressd',


  // Define text color Navigator
  colorTextNavigator: '#d6c290',
  colorIcon: '#444A59',
  colorIconNavigatorActive: '#d6c290',
  sizeIconNavigator: 24,

});
